module.exports = __webpack_public_path__ + "static/img/corrosion-1.c623fbd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/services/corrosion-1.jpg
// module id = v1NM
// module chunks = 0